import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  Button,
} from "@chakra-ui/react";
import React, { useState, useContext } from "react";
import { AppContext } from "contexts/AppContext";

export default function DeleteModal({
  isOpen,
  onClose,
  selectedReservationItem,
  onDeleteEvent,
}) {
  const { fetchReservationData } = useContext(AppContext);
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteError, setDeleteError] = useState("");

  const handleDelete = async () => {
    if (!selectedReservationItem?._id) {
      return;
    }
    setIsDeleting(true);
    setDeleteError("");
    try {
      await onDeleteEvent(selectedReservationItem._id);
      await fetchReservationData();
      onClose();
    } catch (error) {
      setDeleteError(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to delete reservation block."
      );
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader flex={1} textAlign="center">
          Delete Reservation
        </ModalHeader>

        <ModalCloseButton />
        <ModalBody>
          <Button
            fontSize="sm"
            variant="brand"
            fontWeight="500"
            w="100%"
            h="50"
            mb="24px"
            style={{ backgroundColor: "red" }}
            onClick={handleDelete}
            isLoading={isDeleting}
            isDisabled={isDeleting}
          >
            Delete
          </Button>
          {deleteError ? (
            <Text color="red.500" mb="16px" fontSize="sm" fontWeight="500">
              {deleteError}
            </Text>
          ) : null}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
